import { PaldeskModuleFederation } from '@paldesk/module-federation/core';
import { environment } from './environments/environment';
import { showFatalError } from './startup-error-handler';

PaldeskModuleFederation.replaceEnvironmentFile(
  environment.production
    ? 'assets/config/config.json'
    : 'assets/config/config.development.json',
  environment,
)
  .then(() =>
    PaldeskModuleFederation.prepareHost({
      hostName: 'telematic-doctor',
      env: environment.environment,
      remotes: environment.remotes,
    }),
  )
  .then(() => import('./bootstrap'))
  .catch((error: unknown) => showFatalError(error, 'startup'));
